import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import WorkSummaryCard from "./components/WorkSummaryCard";
import WorkStatusGrid from "./components/WorkStatusGrid";
import MonthlyWorkHoursGraph from "./components/MonthlyWorkHoursGraph";
import RecentAttendanceList from "./components/RecentAttendanceList";
import { getUserAttendanceStats } from "../../../../redux/timecard/timeCardState";
import { displayIcon } from "variables/icons";

const EmployeeAttendance = ( ) => {
  const dispatch = useDispatch();
  
  const user = useSelector((state) => state.auth.user);
  const workStats = useSelector((state) => state.timeCard.workStats.data);
  const requesting = useSelector((state) => state.timeCard.workStats.requesting);

  useEffect(() => {
    if (!user) return;

      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
        .toISOString()
        .split("T")[0];
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
        .toISOString()
        .split("T")[0];

      dispatch(getUserAttendanceStats({ userId: user.id, from: firstDay, to: lastDay }));
      }, [user, dispatch]
    );

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-6 rounded-xl border-2 border-blue-200 bg-gradient-to-r from-blue-50 to-cyan-50 p-4 dark:bg-gradient-to-r dark:from-blue-800 dark:to-white/10 dark:border-blue-800">
        <div className="flex items-center gap-3">
          <span className="p-3 rounded-full bg-blue-100">
            {displayIcon('ClipboardCheck', "text-blue-600")}
          </span>
          <div>
            <h3 className="text-sm font-semibold dark:text-white">Standard Working Hours</h3>
            <p className="text-xs text-slate-700 dark:text-slate-100">
              7:00 AM - 4:00 PM (9 hours total, including 1 hour lunch break)
            </p>
          </div>
        </div>
      </div>

      <WorkSummaryCard/>

      <HeaderComponent
        title="Detailed Attendance Breakdown"
        labelIconName="ClipboardCheck"
        description="Comprehensive view of your attendance and work hours"
      >
        <div className="space-y-5">
          <WorkStatusGrid workStats={workStats} requesting={requesting} />
          <MonthlyWorkHoursGraph workStats={workStats} />
          <RecentAttendanceList/>
        </div>
      </HeaderComponent>
    </div>
  );
};

export default EmployeeAttendance;
